import { h } from 'vue'

export default {
  name: 'HorizontalBarChart',
  props: {
    color: { type: Array, default: () => [] },
    labels: { type: Array, default: () => [] },
    data: { type: Array, default: () => [] },
    options: { type: Object, default: () => ({}) }
  },
  computed: {
    datasets () {
      return this.data.filter(dataset => dataset && Array.isArray(dataset.data))
    },
    maximumValue () {
      const values = this.datasets.reduce((values, dataset) => values.concat(dataset.data), [])
      return Math.max(1, ...values.map(value => Number(value) || 0))
    }
  },
  methods: {
    barStyle (dataset, index) {
      const value = Number(dataset.data[index]) || 0
      const colors = Array.isArray(dataset.backgroundColor) ? dataset.backgroundColor : [dataset.backgroundColor]
      return {
        width: `${(value / this.maximumValue) * 100}%`,
        backgroundColor: colors[index] || this.color[index] || '#1991eb',
        minWidth: value > 0 ? '3px' : '0'
      }
    }
  },
  render () {
    return h('div', { class: 'horizontal-bar-chart' }, this.labels.map((label, index) =>
      h('div', { class: 'horizontal-bar-chart__row', key: `${label}-${index}` }, [
        h('span', { class: 'horizontal-bar-chart__label' }, String(label || '')),
        h('div', { class: 'horizontal-bar-chart__bars' }, this.datasets.map((dataset, datasetIndex) =>
          h('div', { class: 'horizontal-bar-chart__track', key: `${dataset.label || datasetIndex}-${index}` }, [
            h('div', { class: 'horizontal-bar-chart__bar', style: this.barStyle(dataset, index) }),
            h('span', { class: 'horizontal-bar-chart__value' }, String(dataset.data[index] || 0))
          ])
        ))
      ])
    ))
  }
}
